module.exports = __webpack_public_path__ + "img/13.c838d0d5.svg";